import { Component, OnInit, Input, HostListener, EventEmitter, ViewChild, Output, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../shared/services/nav-menu-service';
//import { ImageViewerComponent } from '../../../shared/components/ng2-image-viewer';
import { ShoppingBasketService } from "../../../shared/services/shopping-basket.service";
//import { ImageViewerComponent} from 'ng2-image-viewer';
import { RecPlanSearchService } from '../../rec-plan-search-service';
import { PlanImgPage, basketVM } from '../../../shared/viewmodels/ISearchServiceReg';
import { PlanDownloadComponent } from '../../../shared/components/plan-download/plan-download.component';
import { DxPopupComponent, DxPopupModule } from 'devextreme-angular'
import { NgxExtendedPdfViewerComponent, PdfBreakpoints, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-rec-plan-doc-image',
  providers: [RecPlanSearchService],
  templateUrl: './rec-plan-doc-image.component.html',
  styleUrls: ['./rec-plan-doc-image.component.css']
})
export class RecPlanDocImageComponent implements OnInit {

  @Input() planID: string;
  @Input() book: string;
  @Input() page: string;
  public sBook: string;
  public sPage: string;
  @Input() bookType: string;
  public docbeginbook: string;
  public docbeginpage: string; 
  public docType: string;
  public pageCount: number;
  public docID: string;
  public currentIndex: number;
  public currentImageIndex: number;
  public docImages: Array<string>;
  @Input() currentImage: Array<string>;
  public blobImage: string;
  public bufferSize: number = 5;
  public isLoadingImage: boolean = true;
  public showimageviewer: boolean = true;
  public isImgVwVisible: boolean = true;
  error: any;
  evtEmitter = new EventEmitter();
  previewImage: any;
  public imgvwr: any;
  public isFirstPage: boolean;
  public isLastPage: boolean;
  @ViewChild(PlanDownloadComponent, { static: false }) docBasketChild;
  basketItem: basketVM;
  collapseGo: boolean = false;
  collapseReturn: boolean = false;
  screenWidth: any;
  @Output() public changeImgVwVisible = new EventEmitter();
  popupVisible: boolean = false;
  Message: string;
  public path: string;
  planImagePage: Array<PlanImgPage>;
  planImages: Array<string>;
  @ViewChild(NgxExtendedPdfViewerComponent, { static: false }) pdfViewer: NgxExtendedPdfViewerComponent;

  constructor(private route: ActivatedRoute,
    private service: RecPlanSearchService, private SBService: ShoppingBasketService,
    private router: Router, private renderer: Renderer2, public nav: NavMenuService) {
    this.docImages = new Array<string>();
    this.currentImage = new Array<string>();
    this.planImagePage = new Array<PlanImgPage>();
    this.planImages = new Array<string>();
    //this.book = this.route.snapshot.paramMap.get('book');
    //console.log('book: ' + this.book);
    //this.page = this.route.snapshot.paramMap.get('page');
    //console.log('page: ' + this.page);
    //this.bookType = this.route.snapshot.paramMap.get('bookType');
    //console.log('docId: ' + this.bookType);
    this.nav.hide();
    this.getScreenSize();
    pdfDefaultOptions.maxCanvasPixels = -1;
    //PdfBreakpoints.xs = 200;
  }

  /** Initialize image viewer */
  ngOnInit() {
    console.log('ngOnInit() fired');


    this.currentIndex = 1;
    this.currentImageIndex = 0;
    this.docImages = new Array<string>();
    this.isLoadingImage = true;
    this.service.getDocPlanImgByBP(this.book, this.page, 'Recorded').subscribe(
      data => {
        console.log(data.imgType);
        console.log(data.pageList[0].imgPath);
        console.log(data.pageList[0]);
        this.planImagePage = data.pageList;
        console.log(this.planImagePage);
        var pgs: string[] = new Array<string>();
        this.planImagePage.forEach(function (plan) {
          pgs.push(plan.imgPath);
        });
        this.planImages = pgs;
        console.log(this.planImages);
        this.pageCount = data.pageList.length;

        //setup doc record to be used by the basket
        this.docbeginbook = this.book;
        this.docbeginpage = this.page;
        this.docID = this.planID;
        this.docType = 'PL';

        this.getImageByBookPage(this.planImagePage[this.currentIndex - 1].imgPath, this.currentIndex - 1);
        this.changeNavigationbutton(this.pageCount);
        this.isLoadingImage = true;
      }
    )
  }

  searchPlan(sBook, sPage) {
    console.log('new plan ' + sBook + ' ' + sPage);

    this.book = sBook;
    this.page = sPage;

    this.ngOnInit();

    this.sBook = '';
    this.sPage = '';
  }

  getPrevPlan(e) {


    //if (+this.page > 1) {

    //  this.page = (+this.page - 1).toString();
    //  while (this.page.length < 4)
    //    this.page = "0" + this.page;

    //  this.ngOnInit();
    //}

    this.service.GetPlanBP(this.book, this.page, -1).subscribe(
      data => {
        console.log('prev plan ' + data.book);
        this.book = data.book;
        this.page = data.page;
        this.ngOnInit();
      })
  }

  getNextPlan(e) {

    //var pageMax = 1000; //just for testing
    //this.docImages = new Array<string>();

    //if (+this.page < pageMax ) {
    //  this.page = (+this.page + 1).toString();
    //  while (this.page.length < 4)
    //    this.page = "0" + this.page;

    //  this.ngOnInit();
    //}
    this.service.GetPlanBP(this.book, this.page, 1).subscribe(
      data => {
        console.log('prev plan ' + data.book);
        this.book = data.book;
        this.page = data.page;
        this.ngOnInit();
      })
  }

  getImageByBookPage(path: string, page: number, push: boolean = true) {
    console.log("current path and page" + path + page);
    this.service.GetDocPlanPage(path, page).subscribe(
      data => {
        if (push) {
          this.docImages.push(data);
          console.log("push godocplanpage " + this.docImages.length);
          //TODO: code to manage the size of the docImages array
          if (this.docImages.length > this.bufferSize) {
            this.docImages.shift();
            console.log('shift' + this.docImages.length);
            this.currentImageIndex = this.bufferSize;

          }
          else {
            this.currentImageIndex++;
          }
          console.log("docimages and CII " + this.docImages.length + this.currentImageIndex);
        }
        else {
          this.docImages.splice(0, 0, data);
          console.log('splice' + this.docImages.length);
          //TODO: code to manage the size of the docImages array
          if (this.docImages.length > this.bufferSize) {
            this.docImages.pop();
            console.log('pop' + this.docImages.length);
            this.currentImageIndex = 1;
          }
          else {
            this.currentImageIndex = 1;
          }
        }
        console.log("docImages " + this.docImages.length);
        this.showImage((this.currentImageIndex - 1));
      },
      error => { this.error = error }
    );
    this.showimgviewer();
  }

  showImage(idx: number) {
    //console.log("show image idx " + idx  + this.docImages[idx]);
    this.isLoadingImage = true;
    if (this.currentImage.length === 1) {
      this.currentImage.pop();
    }
    this.currentImage.push(this.docImages[idx]);
    this.blobImage = this.docImages[idx];
    this.isLoadingImage = false;
    this.rePaintImgViewer();
    //this.showimgviewer();
  }

  /**
   * Navigate to previous page.
   * @param url
   */
  back(url) {

    this.router.navigate([url]);
    //window.opener = 'Self';
    //window.open('', '_parent', '');
    //window.close();

  }

  showimgviewer() {
    console.log("showimgviewer");
    this.showimageviewer = true;
    this.isImgVwVisible = false;
    this.changeImgVwVisible.emit(this.isImgVwVisible);
  }

  /**
   * Navigate to next page of a document.
   * @param event
   */
  getNextPg(event: Event) {

    this.currentIndex++;

    this.currentImage = new Array<string>();

    console.log("nxt pg CII " + this.currentImageIndex);
        if (this.docImages.length > this.currentImageIndex) {
          this.showImage(this.currentImageIndex);
          this.currentImageIndex++;
        }
        else {
          console.log("nxt pg " + this.planImagePage[this.currentIndex - 1].imgPath);
          this.getImageByBookPage(this.planImagePage[this.currentIndex - 1].imgPath, this.currentIndex-1, true);
        }

        this.changeNavigationbutton(this.pageCount);

  }

  /**
   * Navigate to previous page of a document.
   * @param event
   */
  getPrevPg(event: Event) {
    console.log("prev pg CII " + this.currentImageIndex);
    this.currentImage = new Array<string>();
    this.currentIndex--;
        if (this.currentImageIndex > 1) {
          this.showImage((this.currentImageIndex - 2));
          this.currentImageIndex--;
        }
        else {
          this.getImageByBookPage(this.planImagePage[this.currentIndex - 1].imgPath, this.currentIndex - 1, false);
        }
        this.changeNavigationbutton(this.pageCount);

  }

  checkIfFirstPage(): boolean {
    if (this.currentIndex == 1) {
      return true;
    }
    else
      return false;
  }
  checkIfLastPage(): boolean {
    if (this.currentIndex == this.pageCount) {
      return true;
    }
    else
      return false;
  }

  rePaintImgViewer() {
    //this.imgvwr = new ImageViewerComponent(this.renderer);
    //this.imgvwr.images = this.currentImage;
    //this.imgvwr.idContainer = "idOnHTML";
    //this.imgvwr.download = false;
    //this.showimgviewer();
 
  }

  /**
   * Enable/Disable the navigation button, when its a first page or last page in the document.
   * @param pageCount
   */
  changeNavigationbutton(pageCount: number) {
    // Enable/disable navigation buttons.
    console.log(this.book + "/" + this.page);
    console.log("Next doc page count " + this.pageCount)
    if (this.pageCount > 1) {
      if (this.currentIndex == 1) {
        this.isFirstPage = true;
        this.isLastPage = false;
        console.log("1");
      }
      else if (this.currentIndex == this.pageCount) {
        this.isLastPage = true;
        this.isFirstPage = false;
        console.log("2");
      }
      else {
        this.isLastPage = false;
        this.isFirstPage = false;
        console.log("3");
      }

    }

    else {
      this.isLastPage = true;
      this.isFirstPage = true;
      console.log("4");
    }

    console.log(this.isFirstPage);
    console.log(this.isLastPage);
  }

  /**
   * Navigate to First page in a document.
   * @param event
   */
  getFirstPg(event: Event) {
    console.log("firstpg" + this.pageCount);
    // Get first page from cache if present.
    this.currentImage = new Array<string>();

    if (this.currentIndex <= this.bufferSize && this.currentImageIndex !== 1) {
      this.currentIndex = 1;
      this.currentImageIndex = 1;
      this.showImage(this.currentImageIndex - 1);
      this.changeNavigationbutton(this.pageCount);
    }

    // get first page from service when its not present in cache.
    else {
      this.currentIndex = 1;
      this.currentImageIndex = 0;
      this.docImages.length = 0;
      this.getImageByBookPage(this.planImagePage[this.currentIndex - 1].imgPath, 0, true);
      this.changeNavigationbutton(this.pageCount);
    }
  }

  /**
   * Navigate to Last page in a document.
   * @param event
   */
  getLastPg(event: Event) {
    console.log("lastpg" + this.pageCount)

    this.currentImage = new Array<string>();

    let lastPgIdx: number = this.pageCount - 1;
    this.currentImageIndex = lastPgIdx;

    // Get last page from cache if present.
    if (this.pageCount <= this.bufferSize && this.docImages[lastPgIdx] != null) {
      this.currentImageIndex = this.pageCount - 1;
      this.currentIndex = this.pageCount;
      this.showImage(this.currentImageIndex);
      this.changeNavigationbutton(this.pageCount);
    }


    ////get last page from service when its not present in cache.
    else {
      this.currentImageIndex = 0;
      this.currentIndex = this.pageCount;
      this.docImages.length = 0;
      this.getImageByBookPage(this.planImagePage[this.currentIndex-1].imgPath, 0, false);
      this.changeNavigationbutton(this.pageCount);
    }
  }


  allowDrop(ev) {
    console.log("allow drop");
    ev.preventDefault();
  }

  drag(ev) {
    console.log("drag");
    ev.dataTransfer.setData("text", ev.target.id);
  }

  drop(planImages, book, page, currentindex) {
    console.log("drop");
    console.log("planImages" + planImages + "book" + book + "page" + page + "currentindex" + currentindex);

    const index = this.docBasketChild.basketItems.findIndex(item => item.book === book && item.page === page && item.wholeDoc === false);
    if (index > -1) {
      if (this.docBasketChild.basketItems[index].pages.indexOf((currentindex -1).toString()) > -1) {
        console.log("Duplicate entry");
        this.Message = "Plan Book/Page " + book + "/" + page + ", p." + (currentindex) + " is already added.";
        this.popupVisible = true;
      }
      else {
        this.docBasketChild.basketItems[index].pageCount = this.docBasketChild.basketItems[index].pageCount + 1;
        this.docBasketChild.basketItems[index].pages.push((currentindex -1).toString());
        this.docBasketChild.basketItems[index].imagepaths.push(planImages[currentindex - 1]);
        console.log("Updated entry");
        this.Message = "Plan Book/Page " + book + "/" + page + ", p." + (currentindex) + " is added successfully.";
        this.popupVisible = true;
      }
    }

    else {
      this.basketItem = new basketVM();
      this.basketItem.document = 'B:' + book + '/P:' + page;
      this.basketItem.book = book;
      this.basketItem.page = page;
      this.basketItem.isEmail = false;
      this.basketItem.isDownload = false;
      this.basketItem.downloadAs = 'pdf';
      this.basketItem.wholeDoc = false;
      this.basketItem.pageCount = 1;
      this.basketItem.pages = new Array<string>((currentindex -1).toString());
      this.basketItem.imagepaths = new Array<string>(planImages[currentindex - 1]);

      this.docBasketChild.basketItems.push(this.basketItem);
      //update local storage
      if (localStorage.getItem("planbasket") !== null && localStorage.getItem("planbasket").length > 0) {
        let basketls = JSON.parse(localStorage.getItem("planbasket"));
        basketls.push(this.basketItem);
        localStorage.setItem("planbasket", JSON.stringify(basketls));
      }

      console.log("Added entry");
      this.Message = "Plan Book/Page " + book + "/" + book + ", p." + (currentindex) + " is added successfully.";
      this.popupVisible = true;
      
    }
    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      this.SBService.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.SBService.updateBasketCount(0);
  }

  toggleGo() {
    this.collapseGo = !this.collapseGo;
  }

  toggleReturn() {
    this.collapseReturn = !this.collapseReturn;
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

  collapsesideinfo: boolean = false;

  toggleSideInfo() {
    this.collapsesideinfo = !this.collapsesideinfo;
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

}
